import React from 'react'
import styles from './SimpleForm.module.css'
import classNames from 'classnames'

export function FormRow ({ children, className }) {
  return <div className={classNames(styles.containerRow, className)}>
    {children}
  </div>
}
